import { Container, Carousel, Image } from 'react-bootstrap'

const TakeAPeek = () => (
    <>
    <div className="TakeAPeek">
        <Container>
            <h2 className="text-center text-white mb-5">TAKE A PEEK AT WHAT’S INSIDE</h2>
            <Carousel>
                <Carousel.Item>
                    <Image alt="7 Ways Inside 1" src="../images/7ways/img-slide-whats-inside01.jpg"/>
                </Carousel.Item>
                <Carousel.Item>
                    <Image alt="7 Ways Inside 2" src="../images/7ways/img-slide-whats-inside02.jpg"/>
                </Carousel.Item>
                <Carousel.Item>
                    <Image alt="7 Ways Inside 3" src="../images/7ways/img-slide-whats-inside03.jpg"/>
                </Carousel.Item>
                <Carousel.Item>
                    <Image alt="7 Ways Inside 4" src="../images/7ways/img-slide-whats-inside04.jpg"/>
                </Carousel.Item>
                <Carousel.Item>
                    <Image alt="7 Ways Inside 5" src="../images/7ways/img-slide-whats-inside05.jpg"/>
                </Carousel.Item>
                <Carousel.Item>
                    <Image alt="7 Ways Inside 6" src="../images/7ways/img-slide-whats-inside06.jpg"/>
                </Carousel.Item>
            </Carousel>
        </Container>
    </div>
    <style jsx global>{`

        .TakeAPeek {
            background: #47d9bf;
        }

        .TakeAPeek .container {
            padding-top: 50px;
            padding-bottom: 140px;
        }

        .TakeAPeek h2 {
            font-size: 2rem;
            letter-spacing: 1px;
        }

        .TakeAPeek .carousel {
            max-width: 550px;
            margin: 0px auto;
        }

        .TakeAPeek .carousel .carousel-indicators {
            bottom: -60px;
        }

        .TakeAPeek .carousel .carousel-indicators li {
            width: 16px;
            height: 16px;
            background: #fff;
            border: none;
            margin: 0px 4px;
            border-radius: 10px;
            opacity: 1;
        }

        .TakeAPeek .carousel .carousel-indicators .active {
            background: #2d8878;
        }

        .TakeAPeek .carousel .carousel-control-prev,
        .TakeAPeek .carousel .carousel-control-next {
            background: none;
            font-size: 3rem;
            color: #fff;
            text-shadow: none;
        }

        .TakeAPeek .carousel .carousel-control span {
            position: absolute;
            top: 50%;
        }

        .TakeAPeek .carousel .carousel-control-prev {
            left: -95px;
            color: #fff;
        }

        .TakeAPeek .carousel .carousel-control-prev span {
            height: 40px;
        }

        .TakeAPeek .carousel .carousel-control-next {
            right: -100px;
        }

        .TakeAPeek .carousel .carousel-control-next span {
            height: 40px;
        }

        @media (max-width: 767px) {	

            .TakeAPeek .container {
                padding-top: 30px;
                padding-bottom: 80px;
            }

            .TakeAPeek h2 {
                font-size: 34px;
                margin-bottom: 25px;
            }

            .TakeAPeek .carousel {
                max-width: 460px;
            }

            .TakeAPeek .carousel .carousel-indicators {
                bottom: -70px;
            }

            .TakeAPeek .carousel .carousel-control-prev {
                left: -10px;
            }

            .TakeAPeek .carousel .carousel-control-next {
                right: -10px;
            }

        }

    `}</style>
    </>
);

export default TakeAPeek;